;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .controller(
      'AttackNoteCtrl',
      function (
        $scope,
        $routeParams,
        AttackFactory,
        ErrorService,
        APP_IMPORTANCE_RANKING,
        ATTACK_STATUS
      ) {
        'ngInject'

        angular.extend($scope, {
          model: {
            attack_status: ATTACK_STATUS,
            attackersLimit: 5
          }
        })

        angular.extend($scope, {
          checkUnknownStatus: checkUnknownStatus,
          checkProbedStatus: checkStatus(ATTACK_STATUS.PROBED.value),
          checkBlockedStatus: checkStatus(ATTACK_STATUS.BLOCKED.value),
          checkExploitedStatus: checkStatus(ATTACK_STATUS.EXPLOITED.value),
          checkSuspiciousStatus: checkStatus(ATTACK_STATUS.SUSPICIOUS.value),
          showAllAttackers: showAllAttackers
        })

        var attackUuid = $routeParams.attackUuid
        var expandValue = 'notes'

        function loadAttack() {
          $scope.loadAttackPromise = AttackFactory.getAttackExpand(
            attackUuid,
            expandValue
          )
            .then(function (response) {
              $scope.model.attack = response.data.attack

              _.each(
                $scope.model.attack.attacksApplication,
                function (attackApplication) {
                  var appImportance = _.find(
                    APP_IMPORTANCE_RANKING,
                    function (importance) {
                      return (
                        importance.value ===
                        attackApplication.application.importance
                      )
                    }
                  )

                  _.extend(attackApplication, {
                    importance_label: appImportance.name
                  })
                }
              )
            })
            .catch(ErrorService.processError)
        }

        function init() {
          $scope.$emit('attack.tab.active', { active: 'notes' })
          loadAttack()
        }

        function checkUnknownStatus(attackStatus) {
          return (
            !checkStatus(ATTACK_STATUS.PROBED.value)(attackStatus) &&
            !checkStatus(ATTACK_STATUS.PROBED_PERIMETER.value)(attackStatus) &&
            !checkStatus(ATTACK_STATUS.BLOCKED.value)(attackStatus) &&
            !checkStatus(ATTACK_STATUS.BLOCKED_PERIMETER.value)(attackStatus) &&
            !checkStatus(ATTACK_STATUS.EXPLOITED.value)(attackStatus) &&
            !checkStatus(ATTACK_STATUS.SUSPICIOUS.value)(attackStatus)
          )
        }

        function checkStatus(statusToCheckFor) {
          return function (attackStatus) {
            return attackStatus === statusToCheckFor
          }
        }

        function showAllAttackers() {
          $scope.model.attackersLimit = undefined
        }

        init()
      }
    )
})()
